import React, { useState, useRef } from "react";
import { X, Loader2, ImportIcon } from "lucide-react";

const UploadBankResponseModal = ({ fileId,filename,file_type, onClose, onSuccess }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [alertModal, setAlertModal] = useState({ show: false, title: "", message: "", data: null });
  const fileInputRef = useRef(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const showAlert = (title, message, data = null) => setAlertModal({ show: true, title, message, data });

  const handleFileChange = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
  console.log(f);
  console.log("filename",filename)
    if (!f.name.match(/\.(csv|xlsx|xls)$/)) {
      showAlert("Error", "Please select a valid CSV, XLSX file");
      e.target.value = "";
      return;
    }
    const fileBaseName = f.name.replace(/\.[^/.]+$/, ""); // remove extension
const expectedName = `${filename}_RES`;
if (fileBaseName !== expectedName) {
  showAlert("Error", "File name does not match the required format.");
  return;
}
    setSelectedFile(f);
  };

  const handleDragOver = (e) => { e.preventDefault(); e.stopPropagation(); };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const f = e.dataTransfer.files[0];
    if (!f) return;
    if (!f.name.match(/\.(csv|xlsx|xls)$/)) {
      showAlert("Error", "Please select a valid file");
      return;
    }
    const fileBaseName = f.name.replace(/\.[^/.]+$/, ""); // remove extension
const expectedName = `${filename}_RES`;
if (fileBaseName !== expectedName) {
  showAlert("Error", "File name does not match the required format.");
  return;
}
    setSelectedFile(f);
  };

const getFormattedFileName = (filename) => {
  if (!filename) return "";

  const lastDotIndex = filename.lastIndexOf(".");

  // If extension exists → remove it
  const name =
    lastDotIndex !== -1
      ? filename.substring(0, lastDotIndex).trim()
      : filename.trim();

  return `${name}_RES`;
};

  const handleUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("payoutFilesId", fileId);

    try {
      setUploading(true);
      const token = localStorage.getItem("superadmintoken");

      const res = await fetch(`${BASE_URL}/payment/upload-bank-response`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();

      if (data?.success) {
        showAlert("Success", "Bank response processed successfully.", data.data);
        onSuccess?.();
      } else {
        showAlert("Error", data?.message || "Upload failed. Please try again.");
      }
    } catch {
      showAlert("Upload Failed", "Something went wrong. Please try again.");
    } finally {
      setUploading(false);
    }
  };


    const handlereferralandincentiveUpload = async () => {
    if (!selectedFile) return;
    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("payoutFilesId", fileId);

    try {
      setUploading(true);
      const token = localStorage.getItem("superadmintoken");

      const res = await fetch(`${BASE_URL}/payment/upload-incentive-referral-bank-response`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      const data = await res.json();

      if (data?.success) {
        showAlert("Success", "Bank response processed successfully.", data.data);
        onSuccess?.();
      } else {
        showAlert("Error", data?.message || "Upload failed. Please try again.");
      }
    } catch {
      showAlert("Upload Failed", "Something went wrong. Please try again.");
    } finally {
      setUploading(false);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    if (fileInputRef.current) fileInputRef.current.value = "";
    onClose();
  };

  return (
    <>
      {/* ── Upload Modal ── */}
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[1000]">
        <div className="bg-gray-100 rounded-lg p-6 max-w-xl w-full mx-4 min-h-[300px] border border-gray-300">

          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <h2 className="text-xl font-semibold text-gray-800">Upload Bank Response</h2>
            
            <button onClick={handleClose}>
              <X className="h-5 w-5 text-gray-500 hover:text-gray-700" />
            </button>
          </div>
<div className="mb-4 px-3 py-2 rounded-md bg-yellow-50 border border-yellow-200 text-sm text-yellow-700">
  File name should follow format: <span className="font-semibold">
  {getFormattedFileName(filename)}
</span>
</div>

          {/* Hidden file input */}
          <input
            ref={fileInputRef}
            type="file"
            accept=".csv,.xlsx,.xls"
            onChange={handleFileChange}
            className="hidden"
          />

          {/* Drop Zone */}
          <div
            onClick={() => fileInputRef.current.click()}
            onDragOver={handleDragOver}
            onDrop={handleDrop}
            className="border-2 border-dashed border-gray-300 rounded-lg p-8 text-center cursor-pointer hover:border-indigo-500 transition"
          >
            <ImportIcon className="h-10 w-10 mx-auto text-gray-400 mb-3" />
            <p className="text-gray-600 font-medium">Click to upload or drag and drop</p>
            <p className="text-sm text-gray-400 mt-1">CSV, XLSX files only</p>

            {selectedFile && (
              <div className="flex justify-center items-center gap-2 mt-3 text-sm text-green-600 font-semibold">
                <span>{selectedFile.name}</span>
                <X
                  className="h-4 w-4 text-red-500 cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedFile(null);
                    if (fileInputRef.current) fileInputRef.current.value = "";
                  }}
                />
              </div>
            )}
          </div>

          {/* Upload Button */}
          <button
            onClick={
  file_type === "daily_payout"
    ? handleUpload
    : handlereferralandincentiveUpload
}
            disabled={!selectedFile || uploading}
            className="w-full mt-4 px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center justify-center gap-2"
          >
            {uploading ? (
              <><Loader2 className="h-4 w-4 animate-spin" /> Uploading...</>
            ) : "Upload File"}
          </button>

        </div>
      </div>

      {/* ── Alert Modal ── */}
      {alertModal.show && (
        <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[1100]">
          <div className="bg-white rounded-lg p-6 max-w-sm w-full shadow-lg">
            <div className="flex flex-col items-center text-center">
              {alertModal.title === "Success" ? (
                <div className="mb-3 flex items-center justify-center w-12 h-12 rounded-full bg-green-100">
                  <span className="text-green-600 text-2xl">✓</span>
                </div>
              ) : (
                <div className="mb-3 flex items-center justify-center w-12 h-12 rounded-full bg-red-100">
                  <span className="text-red-600 text-2xl">✕</span>
                </div>
              )}
              <h3 className={`text-lg font-semibold mb-1 ${alertModal.title === "Success" ? "text-green-600" : "text-red-600"}`}>
                {alertModal.title}
              </h3>
              <p className="text-sm text-gray-600 mb-4">{alertModal.message}</p>
            </div>

            {/* Count breakdown — only shown on success when data is available */}
            {alertModal.title === "Success" && alertModal.data && (
              <div className="w-full mb-4 divide-y divide-gray-100 border border-gray-100 rounded-lg overflow-hidden">
                <div className="flex justify-between items-center px-4 py-2.5 text-sm">
                  <span className="text-gray-500">Successful</span>
                  <span className="font-medium text-green-600">{alertModal.data.successCount}</span>
                </div>
                <div className="flex justify-between items-center px-4 py-2.5 text-sm">
                  <span className="text-gray-500">Failed</span>
                  <span className="font-medium text-red-500">{alertModal.data.failedCount}</span>
                </div>
                <div className="flex justify-between items-center px-4 py-2.5 text-sm">
                  <span className="text-gray-500">Skipped</span>
                  <span className="font-medium text-gray-700">{alertModal.data.skippedCount}</span>
                </div>
              </div>
            )}

            <button
              onClick={() => {
                setAlertModal({ show: false, title: "", message: "", data: null });
                if (alertModal.title === "Success") handleClose();
              }}
              className="w-full px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700"
            >
              OK
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default UploadBankResponseModal;